import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Paper  from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {Grid} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import {BrowserRouter as Router , Switch, Route, Link, withRouter} from 'react-router-dom';
import MUIDataTable from "mui-datatables";

import IconResidents from '@material-ui/icons/Group';
import IconChart from '@material-ui/icons/Assessment';
import IconCareplan from '@material-ui/icons/ListAlt';
import IconVitals from '@material-ui/icons/Accessibility';
import IconNotes from '@material-ui/icons/Notes';
import IconActivity from '@material-ui/icons/LocalHotel';
import IconDiet from '@material-ui/icons/Fastfood';
import IconMeds from '@material-ui/icons/LocalHospital';
import IconLabs from '@material-ui/icons/Colorize';


import ScreenResidents from './../../images/screens/spec_residents.png';
import ResidentsDatatable from './ResidentsTable';

import ScreenChart from './../../images/screens/spec_chart.png';
import ScreenCareplan from './../../images/screens/spec_careplan.png';
import ScreenVitals from './../../images/screens/spec_vitals.png';
import ScreenNotes from './../../images/screens/spec_notes.png';
import ScreenActivity from './../../images/screens/spec_activity.png';
import ScreenDiet from './../../images/screens/spec_diet.png';
import ScreenMeds from './../../images/screens/spec_meds.png';
import ScreenLabs from './../../images/screens/spec_labs.png';



// Menu Component Mapping ===================================================

const admin_menu_data = [
    {
        title: 'Residents',
        link:'all',
        desc:'',
        icon: <IconResidents/>,
        data:[

        ]
    },
    {
      title: 'Chart',
      link:'chart',
      icon: <IconChart/>,
      desc:'',
  },
  /*{
    title: 'Chart/medical',
    link:'chart/medical',
    icon: <IconChart/>,
    desc:'',
},
{
  title: 'Chart/family',
  link:'chart/family',
  icon: <IconChart/>,
  desc:'',
},
{
  title: 'Chart/insurance',
  link:'chart/insurance',
  icon: <IconChart/>,
  desc:'',
},
{
  title: 'Chart/personal',
  link:'chart/personal',
  icon: <IconChart/>,
  desc:'',
},*/
{
        title: 'Careplan',
        link:'careplan',
        icon: <IconCareplan/>,
        desc:'',
    },
    {
        title: 'Vitals',
        link:'vitals',
        icon: <IconVitals/>,
        desc:'',
    },
    {
        title: 'Notes',
        link:'notes',
        icon: <IconNotes/>,
        desc:'',
    },
    {
        title: 'ADL',
        link:'activity',
        icon: <IconActivity/>,
        desc:'',
    },
    {
        title: 'Diet',
        link:'diet',
        icon: <IconDiet/>,
        desc:'',
    },
    {
      title: 'Meds',
      link:'meds',
      icon: <IconMeds/>,
      desc:'',
  },
  {
    title: 'Labs',
    link:'labs',
    icon: <IconLabs/>,
    desc:'',
},
]
// Tab Panel ===================================================

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

// Styles ===================================================

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    width: '100%',

    '& header': {
      background: '#ffffff',
      background: '-moz-linear-gradient(top,  #ffffff 0%, #e6eff4 100%)',
      background: '-webkit-linear-gradient(top,  #ffffff 0%,#e6eff4 100%)',
      background: 'linear-gradient(to bottom,  #ffffff 0%,#e6eff4 100%)',
      filter: 'progid:DXImageTransform.Microsoft.gradient( startColorstr="#ffffff", endColorstr="#e6eff4",GradientType=0 )',
      color: '#000000',
    },
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  section_menu:{
    marginTop: 2,
  },
  breadcrumbs:{
    color: '#999',
    marginLeft: 10,
    padding: 4,
    '& a:link, a:visited, a:active': {
      color: '#4499cc',
    },
  },
  bar: {
    background: '#5592de',
  },
  tabpanel:{
    
    '& .panelinfo':{
      textAlign: 'right',
    },
      '& h2':{
        color: '#436f96',
        textAlign:'left',
        textTransform: 'capitalize',
      }
      ,
      '& img':{
        backgroundColor: '#fff',
        //padding: '20px 30px',
        width: '100%',
        maxWidth: 1300,
        margin: 'auto',
        borderRadius:6,
        opacity: 1,
        border: '1px solid #bcd',
        boxShadow: '3px 6px 6px #8795a5',
      },

  },
  tab_style:{
    minWidth: '120px !important',
    borderLeft: '1px solid #ccc',
    color: '#436f96',
    '&:last-child':{
      borderRight: '1px solid #ccc',
    
    }
  },
  gridscreen:{
    margin: 'auto',
  },

  screenshot:{
    
    padding: 10,
    margin: 10,
    backgroundColor: '#dde6ec',
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#dde6ec+0,ffffff+100 */
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,dde6ec+100 */
    background: "-moz-linear-gradient(top,  #ffffff 0%, #dde6ec 100%)", /* FF3.6-15 */
    background: "-webkit-linear-gradient(top,  #ffffff 0%,#dde6ec 100%)", /* Chrome10-25,Safari5.1-6 */
    background: "linear-gradient(to bottom,  #ffffff 0%,#dde6ec 100%)", /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: "progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#dde6ec',GradientType=0 )", /* IE6-9 */
    '& img':{
      width: '100%',
      background: '#fff',
    }
    ,
    '& h2':{
      maxWidth: 1340,
      margin: 'auto',
      marginBottom: 10,
    }
  },
}));


function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}

// Export Main Component ===================================================

export default  function ResidentSection(props){

  const tabNameToIndex = {
    0: 'all',
    1: 'chart',
    2:'careplan',
    3: 'vitals',
    4: 'notes',
    5: 'activity',
    6: 'diet',
    7: 'meds',
    8: 'labs',
  }
  const indexToTabName = {
    'all': 0,
    'chart': 1,
    'careplan': 2,
    'vitals': 3,
    'notes': 4,
    'activity': 5,
    'diet': 6,
    'meds': 7,
    'labs': 8,
  }
  console.log('props',props)
  const {match, history} = props;
  const {params} =  match;
  const {page} = params;

  const classes = useStyles();
  //const [value, setValue] = React.useState(0);
  const [section, setSection] = React.useState(page);
  const [selectedTab, setSelectedTab] = React.useState(indexToTabName[page]);
  
  //setSelectedTab(indexToTabName[page]);
  //setSection(admin_menu_data[indexToTabName[page]]['link']);
// HandleTabChange ===================================================

  const handleTabChange = (event, newValue) => {
    history.push(`/residents/${tabNameToIndex[newValue]}`);
    setSelectedTab(newValue);
    setSection(admin_menu_data[newValue]['link']);
  }
  
/*
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSection(admin_menu_data[newValue]['link']);
    
  };
  */
/*
  handleCallToRouter = (value) => {
    this.props.history.push(value);

    setSection(admin_menu_data[value]['link']);
    
  }
*/
// RENDER ===================================================
  return (
    <div className={classes.root}>
      {/*
      <div className={classes.breadcrumbs}>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          <Link color="inherit" href="/" onClick={handleClick}>
            Material-UI
          </Link>
          <Link color="inherit" href="/getting-started/installation/" onClick={handleClick}>
            Core
          </Link>
          <Typography color="textPrimary">Breadcrumb</Typography>
        </Breadcrumbs>
      </div>
      */}
      <AppBar position="static" className={classes.section_menu}>
        <Tabs 
        centered
        textColor="#ffffff"
        TabIndicatorProps={{
            style: {
              backgroundColor: "#88bbee"
            }
          }}
        value={indexToTabName[page]} 
        onChange={handleTabChange} 
        aria-label="tabs sample: residents">
        {admin_menu_data.map((item, index) =>
            //<Link to={'/admin/'+item.link}> <Tab key={index} value={index} label={item.title} {...a11yProps(index) }>{item.title}</Tab> </Link>
           <Tab className={classes.tab_style} icon={item.icon} compnent={Link} to={'/admin/'+item.link} key={index} value={index} label={item.title} {...a11yProps(index) }>{item.title}</Tab>
            )}
          
        </Tabs>
        
      </AppBar>
      
      <div className={classes.tabpanel}>
      <Paper variant="outlined" className={classes.screenshot} >
        {/*
        <div className="panelinfo">
            <div>section : {section}</div>
            <div>index : {indexToTabName[section]}</div>
            <div>page : {page}</div>
            <div>selectedTab : {selectedTab}</div>
        </div>
        */}
        <Grid container spacing={2}>
          <Grid item xs={12} lg={10} className={classes.gridscreen}>
              {indexToTabName[page] === 0 && 
              <TabPanel value={selectedTab}  index={indexToTabName[section]}>
              {/*
              <h2>{section}</h2>
              <img src={ScreenResidents}  />
              */}
              <ResidentsDatatable/>
              </TabPanel>
              }
              {indexToTabName[page] === 1 && 
              <TabPanel value={selectedTab}  index={indexToTabName[section]}>
              <h2>{section}</h2>
              <img src={ScreenChart}  />
              </TabPanel>
              }
              {indexToTabName[page] === 2 && 
              <TabPanel value={selectedTab}  index={indexToTabName[section]}>
                <h2>{section}</h2>
                <img src={ScreenCareplan}  />
              </TabPanel>
              }
              {indexToTabName[page] === 3 && 
              <TabPanel value={selectedTab}  index={indexToTabName[section]}>
                <h2>{section}</h2>
                <img src={ScreenVitals}  />
              </TabPanel>
              }
              {indexToTabName[page] === 4 && 
              <TabPanel value={selectedTab}  index={indexToTabName[section]}>
                <h2>{section}</h2>
                <img src={ScreenNotes}  />
              </TabPanel>
              }
              {indexToTabName[page] === 5 && 
              <TabPanel value={selectedTab}  index={indexToTabName[section]}>
                <h2>{section}</h2>
                <img src={ScreenActivity}  />
              </TabPanel>
              }
              {indexToTabName[page] === 6 && 
              <TabPanel value={selectedTab}  index={indexToTabName[section]}>
                <h2>{section}</h2>
                <img src={ScreenDiet}  />
              </TabPanel>
              }
              {indexToTabName[page] === 7 && 
              <TabPanel value={selectedTab}  index={indexToTabName[section]}>
                <h2>{section}</h2>
                <img src={ScreenMeds}  />
              </TabPanel>
              }
              {indexToTabName[page] === 8 && 
              <TabPanel value={selectedTab}  index={indexToTabName[section]}>
                <h2>{section}</h2>
                <img src={ScreenLabs}  />
              </TabPanel>
              }
          </Grid>
        </Grid>
        </Paper>
        
      </div>
    </div>
  );
}
/*
  
        <TabPanel value={value} index={2}>
        <h2>{section}</h2>
        <DemoTable admin_section='clinicians' />
        </TabPanel>
        
        <TabPanel value={value} index={3}>
        <h2>{section}</h2>
        <DemoTable admin_section='pharmacies' />
        </TabPanel>
        
        <TabPanel value={value} index={4}>
        <h2>{section}</h2>
        <DemoTable admin_section='prescriptions' />
        </TabPanel>
        
        <TabPanel value={value} index={5}>
        <h2>{section}</h2>
        <DemoTable admin_section='labs' />
        </TabPanel>
        
        <TabPanel value={value} index={6}>
        <h2>{section}</h2>
        <DemoTable admin_section='activities' />
        </TabPanel>
        
        <TabPanel value={value} index={7}>
        <h2>{section}</h2>
        <DemoTable admin_section='vitals' />
        </TabPanel>
        */